// In-memory-only token store. Never localStorage / sessionStorage — per
// FRONTEND.md §3 and §12. A page reload clears the token, which is fine for
// the dev flow; production will mint a fresh session token per request via
// App Bridge.

let currentToken: string | null = null;
let currentMerchantId: string | null = null;
const listeners = new Set<() => void>();

export interface TokenState {
  readonly token: string;
  readonly merchantId: string;
  readonly expiresAt: number; // epoch ms
}

let expiresAt: number | null = null;

export function setToken(state: TokenState): void {
  currentToken = state.token;
  currentMerchantId = state.merchantId;
  expiresAt = state.expiresAt;
  for (const fn of listeners) fn();
}

export function clearToken(): void {
  currentToken = null;
  currentMerchantId = null;
  expiresAt = null;
  for (const fn of listeners) fn();
}

export function getToken(): string | null {
  if (expiresAt !== null && Date.now() >= expiresAt) {
    clearToken();
    return null;
  }
  return currentToken;
}

export function getMerchantId(): string | null {
  return currentMerchantId;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
